import type { TranslationMessages } from '../types';

export const policies: TranslationMessages = {
  name: 'Policy |||| Policies',
  title: 'Policy Management',
  subtitle: 'Manage policies and extract them from chat history',
  create: 'Create Policy',
  consent: 'I Consent',
  consented: 'You have consented to this policy',
  consent_success: 'You have consented to this policy',
  consent_failed: 'Failed to consent to policy',
  ask_question: 'Ask Question',
  ask_question_desc: 'Ask a question about: {{title}}',
  question: 'Question',
  question_placeholder: 'Enter your question about this policy...',
  question_required: 'Please enter a question',
  question_submitted: 'Your question has been submitted',
  question_failed: 'Failed to submit question',
  submit_question: 'Submit Question',
  your_questions: 'Your Questions',
  answer: 'Answer',
  pending_answer: 'Pending answer...',
  question_type: 'Question Type',
  ask_ai: 'Ask AI Assistant',
  ask_manager: 'Ask Manager',
  ai_desc: 'Get an instant answer from the AI assistant',
  manager_desc: 'Submit your question for a manager to answer',
  asking_ai: 'Asking AI...',
  ai_answer: 'AI',
  ai_answer_label: 'AI Answer',
  ai_answer_received: 'AI assistant has answered your question',
  pending: 'Pending',
  continue_conversation: 'Continue Conversation',
  conversation_history: 'Conversation History',
  you: 'You',
  ai: 'AI',
  max_messages_reached:
    'You have reached the maximum number of messages (10). Please ask a manager directly for further assistance.',
  max_messages_warning:
    'You have reached the maximum number of messages. Please ask a manager directly.',
  send_message: 'Send Message',
  ai_continue_desc: 'Continue the conversation with AI assistant',
  edit: 'Edit Policy',
  delete: 'Delete Policy',
  update: 'Update Policy',
  search: 'Search policies...',
  all: 'All',
  active_only: 'Active',
  inactive_only: 'Inactive',
  total: 'Total Policies',
  active: 'Active',
  inactive: 'Inactive',
  from_chat: 'From Chat',
  no_policies: 'No Policies Found',
  create_first: 'Create your first policy or extract from chat history',
  load_failed: 'Failed to load policies',
  created: 'Policy created successfully',
  updated: 'Policy updated successfully',
  deleted: 'Policy deleted successfully',
  create_failed: 'Failed to create policy',
  update_failed: 'Failed to update policy',
  delete_failed: 'Failed to delete policy',
  validation_error: 'Please fill in all required fields',
  delete_confirmation:
    'Are you sure you want to delete this policy? This action cannot be undone.',
  extract_from_chat: 'Extract from Chat',
  extracting: 'Extracting...',
  extract_description:
    'Review chat history and create policies from assistant messages',
  no_chat_history: 'No chat history found',
  no_policies_in_chat: 'No policies found in chat history',
  extract_failed: 'Failed to extract from chat',
  chat_messages_count: 'Found %{count} messages in chat history',
  use_as_policy: 'Use as Policy',
  title_label: 'Title',
  title_placeholder: 'Enter policy title',
  description_label: 'Description',
  description_placeholder: 'Enter description (optional)',
  content_label: 'Content',
  content_placeholder: 'Enter policy content',
  applicable_processes_label: 'Applicable Processes',
  process_placeholder: 'Enter process name and press Enter',
  tags_label: 'Tags',
  tag_placeholder: 'Enter tag and press Enter',
  is_active: 'Active',
  priority_label: 'Priority',
  add: 'Add',
  create_description: 'Create a new policy that can be used by the chatbot',
  edit_description: 'Update policy information',
  ai_extract: 'AI Extract Metadata',
  extracting_metadata: 'Extracting...',
  ai_extract_hint:
    'Enter your policy content and click "AI Extract Metadata" to automatically fill title, description, processes, and tags',
  metadata_extracted: 'Policy metadata extracted successfully',
  extract_metadata_failed: 'Failed to extract metadata: {{error}}',
  no_content_for_extraction: 'Please enter policy content first',
  ai_rewrite: 'AI Rewrite',
  rewriting: 'Rewriting...',
  rewritten_content: 'Rewritten Content',
  improvements: 'Improvements:',
  approve: 'Approve',
  reject: 'Reject',
  content_rewritten:
    'Content rewritten successfully. Review and approve or reject the changes.',
  rewrite_failed: 'Failed to rewrite content: {{error}}',
  rewrite_approved: 'Rewritten content approved and applied',
  rewrite_rejected: 'Rewritten content rejected',
  no_content_for_rewrite: 'Please enter policy content first',
  };
